var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"secure-display-text"},[(!_vm.showText)?_c('span',[_vm._v(_vm._s(_vm.hideText))]):_c('span',[_vm._v(_vm._s(_vm.text))]),_c('el-button',{staticClass:"show-btn",attrs:{"type":"text","size":"mini"},on:{"click":_vm.toggleShowText}},[_vm._v(_vm._s(_vm.showText ? '隐藏' : '展示'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }